/**
 * @deprecated - use the Data Layer for analytics
 */ const setUserObject = (isLoggedIn = false)=>{
    if (typeof window === 'undefined') {
        return;
    }
    // Create empty user object if it not yet exists
    if (!window.grandvision || !window.grandvision.user) {
        window.grandvision = {
            user: {}
        };
    }
    window.grandvision.user = {
        loggedIn: isLoggedIn
    };
};

export { setUserObject };
//# sourceMappingURL=user.js.map
